import LineSmaller from './LineSmaller';
import LineSmallerALt from './LineSmallerAlt';
import LineSmall from './LineSmall';
import LineSmallALt from './LineSmallAlt';
import LineMedium from './LineMedium';
import LineMediumAlt from './LineMediumAlt';
import LineLarge from './LineLarge';
import LineLargeAlt from './LineLargeAlt';

import Circle from './Circle';
import Letter from './Letter';
import Return from './Return';

export default {
    smaller: LineSmaller,
    'smaller-alt': LineSmallerALt,
    small: LineSmall,
    'small-alt': LineSmallALt,
    medium: LineMedium,
    'medium-alt': LineMediumAlt,
    large: LineLarge,
    'large-alt': LineLargeAlt,
    circle: Circle,
    letter: Letter,
    return: Return,
};
